import React, { Suspense, useEffect, useState } from 'react'
import { Modal } from '@web/walter-ui-kit'

import { Content } from './Content'
import SuspenseLoader from '~components/SuspenseLoader'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'
import { useMigrationStatus } from '~api'

/**
 * MigrationModal
 */
function MigrationModal() {
    const { data: migrationStatusData } = useMigrationStatus()
    const { isOpen, show } = useModal(ModalTypes.migration)
    const [isSumSubOpen, setSumSubOpen] = useState(false)

    useEffect(() => {
        if (migrationStatusData?.fw_migration_start && !migrationStatusData?.fw_migration_finish) {
            show()
        }
    }, [show, migrationStatusData?.fw_migration_start, migrationStatusData?.fw_migration_finish])

    return (
        <Modal
            size="m"
            ignoreEscape
            onClose={() => setSumSubOpen(false)}
            isOpen={isOpen}
            withCloseButton={isSumSubOpen}
            dataPointer="migration_modal"
        >
            <Suspense fallback={<SuspenseLoader />}>
                <Content isSumSubOpen={isSumSubOpen} setSumSubOpen={setSumSubOpen} />
            </Suspense>
        </Modal>
    )
}

export default MigrationModal
